import NoPreview from './NoPreview';

export default NoPreview;
